import { Spinner } from '@poliedro/tamentai';

import ProfileSelectorModal from '../components/organisms/ProfileSelectorModal';
import { useToken } from '../hooks/useToken';
import { useProfileData } from '../services/useProfileData/index';
import { PageContainer, SpinnerContainer } from '../styles/pages';

const InitialPage = () => {
  const { isTokenValid } = useToken();
  const { userData } = useProfileData(isTokenValid === true);

  if (isTokenValid == null || (isTokenValid && !userData)) {
    return (
      <SpinnerContainer>
        <Spinner size={50} />
      </SpinnerContainer>
    );
  }

  return (
    <PageContainer>
      {userData && <ProfileSelectorModal isOpen={true} userData={userData} />}
    </PageContainer>
  );
};

export default InitialPage;
